import { __assign, __rest } from "tslib";
import * as React from 'react';
function getTileClass(cols, rows, _resizable) {
    cols = Math.min(cols, 12);
    rows = Math.min(rows, 12);
    return "tile rows-".concat(rows, " cols-").concat(cols);
}
export var DashboardTile = function (_a) {
    var children = _a.children, columns = _a.columns, rows = _a.rows, _b = _a.resizable, resizable = _b === void 0 ? false : _b, props = __rest(_a, ["children", "columns", "rows", "resizable"]);
    return (React.createElement("div", __assign({}, props, { className: getTileClass(columns, rows, resizable) }), children));
};
//# sourceMappingURL=DashboardTile.js.map